import ClientLayoutPages from "components/ClientLayoutPages/ClientLayoutPages";
import LogoSpinner from "components/Spinner/LogoSpinner";
import Cp from "pages/__ClientPages/Cp/Cp";
import MyOrders from "pages/__ClientPages/MyOrders/MyOrders";
import MyPayments from "pages/__ClientPages/MyPayments/MyPayments";
import UnderMaintenance from "pages/__ClientPages/UnderMaintenance/UnderMaintenance";
import { Error401, Error404 } from "pages/errors";
import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";

const ContactUs = React.lazy(() =>
  import("pages/__ClientPages/ContactUs/ContactUs")
);
const ChangePassword = React.lazy(() =>
  import("pages/__ClientPages/ChangePassword/ChangePassword")
);

const MyProfile = React.lazy(() =>
  import("pages/__ClientPages/MyProfile/MyProfile")
);

const routes = [
  { url: "/", component: <Cp /> },
  { url: "/my-payments", component: <MyPayments /> },
  { url: "/my-orders", component: <MyOrders /> },
  { url: "/contact-us", component: <ContactUs /> },
  { url: "/change-password", component: <ChangePassword /> },
  { url: "/under-maintenance", component: <UnderMaintenance /> },
  { url: "/my-profile", component: <MyProfile /> },
];

const ClientRoutes = () => {
  const { role, permissions } = useSelector((state) => state.auth);

  // التحقق من دور المستخدم
  if (role !== "customer") {
    return <Navigate to="/login" replace />;
  }

  // دالة لتحقق من الصلاحية وإرجاع المسار
  const makeRoute = ({ url, component, permission }) => {
    if (permission) {
      // تحقق من الصلاحية
      if (permissions.includes(permission)) {
        return (
          <Route
            key={url}
            path={url}
            element={
              <Suspense fallback={<LogoSpinner page />}>{component}</Suspense>
            }
          />
        );
      }
      // في حال عدم وجود الصلاحية، إعادة توجيه المستخدم إلى صفحة غير مفوض
      else
        return (
          <Route
            key={url}
            path={url}
            element={<Navigate to="/cp/not-authorized" replace />}
          />
        );
    } else
      return (
        <Route
          key={url}
          path={url}
          element={
            <Suspense fallback={<LogoSpinner page />}>{component}</Suspense>
          }
        />
      );
  };

  return (
    <Routes>
      <Route element={<ClientLayoutPages />}>
        {routes.map(makeRoute)}
        <Route
          path="/not-authorized"
          element={<Error401 navigateTo={"/"} timer={10000} />}
        />
        <Route path="*" element={<Error404 navigateTo={"/"} timer={10000} />} />
      </Route>
    </Routes>
  );
};

export default ClientRoutes;
